export const API_URL = "https://skillcourts-api.skillgam.es/api/";

// export const API_URL = "https://api.beta.skillcourts.com/api/";
export default API_URL;
